import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass, fillStyle, flexColumnStyle, Style } from '../../../style';

const cssPrefix = 'spaces-explorer';

export namespace ExplorerDropdownStyles {
  export const FlyoutButtonPanelContainer = cssClass(cssPrefix, 'flyout-button-panel-container', {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    paddingBottom: TabStyles!.Spacing!.MediumSpace,
    paddingTop: TabStyles!.Spacing!.MediumSpace,
    paddingRight: TabStyles!.Spacing!.DefaultSpace,
    paddingLeft: TabStyles!.Spacing!.DefaultSpace,
    fontSize: TabStyles!.Typography!.Sizing!.Default,
    fontFamily: TabStyles!.Typography!.FontFamily
  });

  const baseExplorerDropdownItemContainer: Style = {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    flexDirection: 'row',
    height: CommonStyles.Sizes.DropdownItemHeight,
    color: TabStyles!.Typography!.Color!.Primary,
    justifyContent: 'space-between',
    paddingRight: TabStyles!.Spacing!.DefaultSpace,
    paddingLeft: TabStyles!.Spacing!.DefaultSpace,
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };

  export const ExplorerDropdownItemContainer = cssClass(cssPrefix, 'explorer-dropdown-item-container', {
    ...baseExplorerDropdownItemContainer,
    cursor: 'pointer',
    $nest: {
      '&:hover': {
        backgroundColor: TabStyles!.Colors!.L2_5,
        color: TabStyles!.Typography!.Color!.Primary
      }
    },
  });

  export const ExplorerDropdownSelectedItemContainer = cssClass(cssPrefix, 'explorer-dropdown-selected-item-container', {
    ...baseExplorerDropdownItemContainer,
    cursor: 'pointer',
    backgroundColor: TabStyles!.Colors!.L2_5,
    color: TabStyles!.Typography!.Color!.Primary
  });

  export const ExplorerDropdownDisabledItemContainer = cssClass(cssPrefix, 'explorer-dropdown-disabled-item-container', {
    ...baseExplorerDropdownItemContainer,
    color: TabStyles!.Typography!.Color!.Disabled
  });

  export const ExplorerDropdownItemHeaderContainer = cssClass(cssPrefix, 'explorer-dropdown-item-header-container', {
    ...baseExplorerDropdownItemContainer,
    color: TabStyles!.Typography!.Color!.Disabled
  });

  export const ExplorerDropdownItemSeparator = cssClass(cssPrefix, 'explorer-dropdown-item-separator', {
    height: 1,
    backgroundColor: TabStyles!.Colors!.L9Disabled,
    marginBottom: TabStyles!.Spacing!.DefaultSpace,
    marginTop: TabStyles!.Spacing!.DefaultSpace
  });

  export const ExplorerDropdownItemCheckandNameContainer = cssClass(cssPrefix, 'explorer-dropdown-item-check-and-name-container', {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'row'
  });

  export const ExplorerDropdownCount = cssClass(cssPrefix, 'explorer-dropdown-count', {
    color: TabStyles!.Typography!.Color!.Disabled,
    minWidth: 36,
    textAlign: 'right',
    marginLeft: TabStyles.Spacing.MediumSpace
  });

  const baseExplorerDropdownButton: Style = {
    backgroundColor: 'white',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between'
  };

  export const ExplorerDropdownButton = cssClass(cssPrefix, 'explorer-dropdown-button', {
    ...baseExplorerDropdownButton,
    $nest: {
      '&:hover': {
        borderBottomColor: TabStyles.Colors.Black
      }
    },
    borderBottomColor: TabStyles.Colors.L6
  });

  export const ExplorerDropdownButtonActive = cssClass(cssPrefix, 'explorer-dropdown-button-active', {
    ...baseExplorerDropdownButton,
    borderBottomColor: TabStyles.Colors.Black
  });

  export const ExplorerDropdownButtonDisabled = cssClass(cssPrefix, 'explorer-dropdown-button-disabled', {
    ...baseExplorerDropdownButton,
    borderBottomColor: TabStyles.Colors.F7Disabled
  });

  export function explorerDropdownButtonClass(showingOrActive: boolean, disabled: boolean) {
    if (disabled) {
      return ExplorerDropdownButtonDisabled;
    }

    if (showingOrActive) {
      return ExplorerDropdownButtonActive;
    }

    return ExplorerDropdownButton;
  }

  export const ExplorerDropdownArrowImg = cssClass(cssPrefix, 'explorer-dropdown-arrow-img', {
    height: 9,
    width: 9,
    verticalAlign: 'bottom',
    marginLeft: TabStyles.Spacing.SmallSpace
  });

  export const ExplorerDropdownButtonGenericStyle: React.CSSProperties = {
    borderWidth: 0,
    padding: 0,
    margin: 0,
    height: 'inherit',
    lineHeight: 'inherit',
    width: '100%',
    fontFamily: CommonStyles.Fonts.HeaderFont
  };

  export const ExplorerDropdownCheckImg = cssClass(cssPrefix, 'explorer-dropdown-check-img', {
    height: 10,
    width: 10,
    marginRight: TabStyles!.Spacing!.DefaultSpace
  });
}
